import { request, success, failure, HOLIDAYS } from "./utilities";
import { getHolidays } from "../api";

const data = [
    {
        day: "Tuesday",
        date: "Jan 01, 2019",
        holiday: "New Years Day"
    },
    {
        day: "Monday",
        date: "Jan 14, 2019",
        holiday: "Makar Sankranti / Pongal"
    },
    {
        day: "Saturday",
        date: "Jan 26, 2019",
        holiday: "Republic Day"
    },
    {
        day: "Monday",
        date: "Mar 04, 2019",
        holiday: "Maha shivaratri"
    }
]

export function getAllHolidays() {
    return (dispatch) => {
        dispatch(success(HOLIDAYS.GET_ALL_HOLIDAYS_SUCCESS, data));
        // dispatch(request(HOLIDAYS.GET_ALL_HOLIDAYS_REQUEST));
        // getHolidays().then((res) => {
        //     if (res.data.status === 1) {
        //         dispatch(success(HOLIDAYS.GET_ALL_HOLIDAYS_SUCCESS, res.data.data));
        //     }
        //     else {
        //         dispatch(failure(HOLIDAYS.GET_ALL_HOLIDAYS_FAILURE, res.data.message));
        //     }
        // }, (error) => {
        //     dispatch(failure(HOLIDAYS.GET_ALL_HOLIDAYS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
        // })
    }
}